export const pixelate = (value) => `${value}px`;

export const MAX_WIDTH = 1700;
export const UNIT = 8;
export const SPACER = 5 * UNIT;

export const SIZE = {
	small: 'small',
	medium: 'medium',
	large: 'large',
	xlarge: 'xlarge',
	max: 'max'
}

export const SIZES = [
	SIZE.small,
	SIZE.medium,
	SIZE.large,
	SIZE.xlarge,
	SIZE.max
]

export const MARGIN = {
	small: 24,
	medium: 24,
	large: 64,
	xlarge: 80,
	max: 80
};

export const GUTTER = {
	small: 16,
	medium: 16,
	large: 24,
	xlarge: 32,
	max: 32
};

export const BREAKPOINT = {
	medium: 768,
	large: 1024,
	xlarge: 1400,
	max: 1600
};

export const mediaQuery = {
	medium: `@media (min-width: ${pixelate(BREAKPOINT.medium)})`,
	large: `@media (min-width: ${pixelate(BREAKPOINT.large)})`,
	xlarge: `@media (min-width: ${pixelate(BREAKPOINT.xlarge)})`,
	max: `@media (min-width: ${pixelate(BREAKPOINT.max)})`
};

export const breakpoint = (size=SIZE.large,{pixelate=true}={pixelate:true}) => pixelate ? `${BREAKPOINT[size]}px` : (BREAKPOINT[size]);
export const margin = (size=SIZE.large,{pixelate=true,multiplier=1}={pixelate:true,multiplier:1}) => pixelate ? `${MARGIN[size] * multiplier}px` : (MARGIN[size] * multiplier);
export const gutter = (size=SIZE.large,{pixelate=true,multiplier=1}={pixelate:true,multiplier:1}) => pixelate ? `${GUTTER[size] * multiplier}px` : (GUTTER[size] * multiplier);
export const unit = (value,{pixelate=true}={pixelate:true}) => pixelate ? `${value * UNIT}px` : (value * UNIT);
export const spacer = (value,{pixelate=true}={pixelate:true}) => pixelate ? `${value * SPACER}px` : (value * SPACER);
export const maxWidth = ({pixelate=true}={pixelate:true}) => pixelate ? `${BREAKPOINT[SIZE.max]}px` : (BREAKPOINT[SIZE.max]);